import { createStore } from "owa-satcheljs";
import type { AppHostSearchStore } from "./schema/AppHostSearchStore";
import type { SearchServiceEventMap } from "@metaos/hub-sdk";

const defaultExport: () => AppHostSearchStore = createStore<AppHostSearchStore>("AppHostSearchStore", {
    isSearchEnabled: false,
    eventRegistrationsMap: new Map<keyof SearchServiceEventMap, (event: any) => void>(),
});
export default defaultExport;
